// Utilities
import baseAxios from "./base"

const CollectionApi = {
  create: params => {
    return baseAxios.post("/hashtag_groups", params)
  },

  all: () => {
    return baseAxios.get("/hashtag_groups")
  },

  fetch: id => {
    return baseAxios.get(`/hashtag_groups/${id}`)
  },

  sync: params => {
    return baseAxios.post("/hashtag_groups/sync", params)
  },

  update: (id, params) => {
    return baseAxios.put(`/hashtag_groups/${id}`, params)
  },

  delete: id => {
    return baseAxios.delete(`/hashtag_groups/${id}`)
  },
}

export default CollectionApi
